<div class="jumpToMenu-hd">Shop by Category</div>
{{#if children}}
    <ul class="jumpToMenu-items">
        {{#each children}}
            <li>
                <a class="jumpToMenu-items-link jumpToMenu-items-link-{{id}}" href="#{{id}}">{{name}}</a>
            </li>
        {{/each}}
    </ul>
{{/if}}
